import axios from 'axios'
import {userLogout} from "../auth/AuthService";
import {store} from "../../redux/store/store"
import {setLicense, setPlatFrom} from "../../redux/slice/authSlice";
import {getToken} from "../../components/commonmethod/CommonMethod";
import {handleServerUnavailable, isNetworkError} from "./serverUnavailable";

const BASE_URL = import.meta.env.VITE_BASE_URL;

const noAuthapi = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

const needAuthapi = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

const setThisPlatForm = (playFormName) => {
    store.dispatch(setPlatFrom(playFormName));
}

noAuthapi.interceptors.request.use((config) => {
    const DNS = window.location.host;
    config.headers['Dns'] = DNS;
    return config;
});

needAuthapi.interceptors.request.use((config) => {
    const token = getToken();
    const DNS = window.location.host
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['Dns'] = DNS;
    }
    const pathname = window.location.pathname;
    config.headers['Pathname'] = `${pathname}`;
    return config;
});

let isRefreshing = false;
let requestQueue = [];

needAuthapi.interceptors.response.use(
    async function (response) {
        const suppressGlobalAlert = String(response?.config?.headers?.["X-Suppress-Global-Alert"] || "").toLowerCase() === "true";
        const license = response.headers['x-license'];
        const platForm = response.headers['x-platform'];

        if (license?.includes('KEY')) {
            if (!suppressGlobalAlert) {
                alert("라이선스 오류.");
            }
            await userLogout();
            window.location.replace("/");
        }

        if (license?.includes('EXPIRED')) {
            if (!suppressGlobalAlert) {
                alert("라이선스 기간 종료되었습니다.");
            }
            await userLogout();
            window.location.replace("/");
        }

        if (platForm) {
            setThisPlatForm(platForm);
        }
        if (license != null && license !== '') {
            store.dispatch(setLicense(license));
        }
        return response;
    },
    async (error) => {
        const { config, response } = error;
        const suppressGlobalAlert = String(config?.headers?.["X-Suppress-Global-Alert"] || "").toLowerCase() === "true";

        if (isNetworkError(error)) {
            if (handleServerUnavailable()) {
                return new Promise(() => {});
            }
            return Promise.reject(error);
        }

        if (response?.status === 401) {
            if (!isRefreshing) {
                isRefreshing = true;
                const refreshToken = localStorage.getItem('refreshToken');

                const tokenRefreshConfig = {
                    headers: {
                        'Authorization': `Bearer ${refreshToken}`,
                    },
                };

                try {
                    const res = await axios.get(BASE_URL + `/user/reissue`, tokenRefreshConfig);
                    const newAccessToken = res.data.accessToken;

                    localStorage.setItem('accessToken', newAccessToken);

                    requestQueue.forEach((cb) => cb(newAccessToken));
                    requestQueue = [];
                    isRefreshing = false;

                    config.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return axios(config);
                } catch (err) {
                    isRefreshing = false;
                    requestQueue = [];
                    if (isNetworkError(err)) {
                        if (handleServerUnavailable()) {
                            return new Promise(() => {});
                        }
                    } else if (!suppressGlobalAlert) {
                        alert("로그인 세션이 만료되어 로그아웃 되었습니다(2).");
                    }
                    await userLogout();
                    window.location.replace("/");
                    return response;
                }
            }

            return new Promise((resolve) => {
                requestQueue.push((newToken) => {
                    config.headers['Authorization'] = `Bearer ${newToken}`;
                    resolve(axios(config));
                });
            });
        }

        if (response?.status === 403) {
        }

        return Promise.reject(error);
    }
);

export const noAuh = noAuthapi
export const needAuth = needAuthapi;
